const cmsImage = (pathName = "") =>
  `${process.env.REACT_APP_CMS_ASSET_URL}assets/images/${pathName}`;
export default cmsImage;
